import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Paper,
} from "@mui/material";
import Loader from "../../../../Common/Loader/loader";
import isGHMC, {
  formatDateTime,
  formatDateTimeWithoutSec,
  formattedDate,
  getCurrentDateTime,
} from "../../../../Common/helper/helpar";
import { NoOfBinsFilter } from "./NoOfBinsFilter";
import NoOfBinsGvpReportStore from "./store/NoOfBinsGvpReportStore";
import TableSkeleton from "../../../AllotedMaster/TableSkeleton";
export const NoOfBinsReport = () => {
  const {
    noOfBinsGvpData,
    loading,
    currentFilters,
    fetchNoOfBinsGvpOuterReport,
  } = NoOfBinsGvpReportStore();
  const navigate = useNavigate();
  const currentDate = getCurrentDateTime();
  // Pagination state
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);

  // Restore filters from localStorage when component mounts (e.g., coming back from inner report)
  useEffect(() => {
    const storedFilters = localStorage.getItem("noOfBinsGvpFilters");
    if (storedFilters) {
      const parsedFilters = JSON.parse(storedFilters);
      // fetchNoOfBinsGvpOuterReport(parsedFilters);
    }
  }, []); // Run only on mount

  // Reset to first page when data changes
  useEffect(() => {
    setPage(0);
  }, [noOfBinsGvpData]);

  const handleDateClick = (date, event) => {
     localStorage.setItem("innerBinReportAllDates","Notall")
    event?.preventDefault();
    event?.stopPropagation();
    navigate(`/inner-no-of-bins-gvp-report`, {
      state: { date, filters: currentFilters },
    });
  };

  const handleDateClickALLDates = ( event) => {

    localStorage.setItem("innerBinReportAllDates","all")
    event?.preventDefault();
    event?.stopPropagation();
    navigate(`/inner-no-of-bins-gvp-report`, {
      state: {filters: currentFilters },
    });
  };

  // Handle page change
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  // Handle rows per page change
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Get paginated data
  const paginatedData = noOfBinsGvpData
    ? noOfBinsGvpData.slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage,
      )
    : [];

  // Calculate totals
  const calculateTotals = () => {
    if (!noOfBinsGvpData || noOfBinsGvpData.length === 0) {
      return {
        totalPointsFromMasters: 0,
        totalBins: 0,
        totalAttendedBins: 0,
        pointsCleared: 0,
        notCleared: 0,
      };
    }

    const totals = noOfBinsGvpData.reduce(
      (acc, row) => {
        acc.totalBins += Number(row.totalBins || 0);
        acc.totalAttendedBins += Number(row.attendedBins || 0);
        acc.pointsCleared += Number(row.pointsCleared || 0);
        acc.notCleared += Number(row.notCleared || 0);
        return acc;
      },
      {
        totalBins: 0,
        totalAttendedBins: 0,
        pointsCleared: 0,
        notCleared: 0,
      },
    );

    return totals;
  };

  const totals = calculateTotals();

  // Styles
  const headerStyle = {
    textAlign: "center",
    border: "1px solid #ddd",
    padding: "10px",
    color: "#fff",
    backgroundColor: isGHMC() ? "#0d5da5" : "#EC1117",
    fontWeight: 600,
    whiteSpace: "nowrap",
  };

  const cellStyle = {
    textAlign: "center",
    border: "1px solid #ddd",
    padding: "8px",
  };

  // Utility to format date strings as DD-MM-YYYY HH:mm:ss
  const formatToDDMMYYYY_HHMMSS = (dateStr) => {
    if (!dateStr) return "";
    const date = new Date(dateStr);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // months are 0-indexed
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");

    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
  };

  // Get stored filter values
  const storedFilters = localStorage.getItem("noOfBinsGvpFilters");
  const parsedFilters = storedFilters ? JSON.parse(storedFilters) : null;

  // Current date-time
  // const currentDate = new Date();

  return (
    <div style={{ width: "100%" }}>
      <div className="content">
        <div className="page-content">
          <NoOfBinsFilter />

          {/* Data Table Section */}
          <div className="card mt-3">
            <div className="card-body">
              <div
                className="top-header p-2"
                style={{
                  backgroundColor: "#D7D7D7",
                  fontWeight: "600",
                  borderBottom: "1px solid #DDDDDD",
                }}
              >
                <span>
                  No of Bins/GVPs Attended Daily Report (
                  {parsedFilters?.StartDate
                    ? formattedDate(parsedFilters.StartDate)
                    : "—"}{" "}
                  to{" "}
                  {parsedFilters?.EndDate
                    ? formattedDate(parsedFilters.EndDate)
                    : "—"}
                  ) at {formatToDDMMYYYY_HHMMSS(currentDate)}
                </span>
              </div>
              {/* Filter & Search Section */}

              {loading ? (
                <TableSkeleton />
              ) : (
                <>
                  <TableContainer
                    component={Paper}
                    sx={{ maxHeight: 500, width: "100%" }}
                  >
                    <Table stickyHeader sx={{ width: "100%" }}>
                      <TableHead>
                        <TableRow>
                          <TableCell sx={headerStyle}>S.No</TableCell>
                          <TableCell sx={headerStyle}>Date</TableCell>
                          {/* <TableCell sx={headerStyle}>Points From Masters</TableCell> */}
                          <TableCell sx={headerStyle}>
                            Total number of bins/GVP's <br />
                            in the All circles (a)
                          </TableCell>
                          <TableCell sx={headerStyle}>
                            Total number of bins/GVP's <br />
                            Attended in the All circles (a)
                          </TableCell>
                          {/* <TableCell sx={headerStyle}>Points Cleared</TableCell> */}
                          <TableCell sx={headerStyle}>
                            Performance Acheived
                          </TableCell>
                          {/* <TableCell sx={headerStyle}>Not Cleared</TableCell> */}
                          {/* <TableCell sx={headerStyle}>Not Cleared %</TableCell> */}
                          <TableCell
                            sx={{
                              ...headerStyle,
                              width: "300px", // Increase width
                              minWidth: "300px",
                            }}
                          >
                            Remarks
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {paginatedData && paginatedData.length > 0 ? (
                          paginatedData.map((row, index) => (
                            <TableRow
                              key={page * rowsPerPage + index}
                              sx={{
                                backgroundColor: isGHMC()
                                  ? index % 2 === 0
                                    ? "#8fc9ff"
                                    : "#aed8ff"
                                  : index % 2 === 0
                                    ? "#F8CCCD"
                                    : "#ffeded",
                              }}
                            >
                              <TableCell sx={cellStyle}>
                                {page * rowsPerPage + index + 1}
                              </TableCell>
                              <TableCell sx={cellStyle}>
                                <span
                                  style={{ color: "blue", cursor: "pointer" }}
                                  onClick={(e) => handleDateClick(row.date, e)}
                                >
                                  {row.date}
                                </span>
                              </TableCell>
                              {/* <TableCell sx={cellStyle}>{row.pointsFromMasters || 0}</TableCell> */}

                              <TableCell sx={cellStyle}>
                                {row.totalBins || 0}
                              </TableCell>
                              <TableCell sx={cellStyle}>
                                {row.attendedBins || 0}
                              </TableCell>

                              {/* <TableCell sx={cellStyle}>{row.pointsCleared || 0}</TableCell> */}
                              <TableCell sx={cellStyle}>
                                {row.clearedPercentage
                                  ? `${row.clearedPercentage}%`
                                  : "0%"}
                              </TableCell>
                              {/* <TableCell sx={cellStyle}>{row.notCleared || 0}</TableCell> */}
                              {/* <TableCell sx={cellStyle}>
                                {row.notClearedPercentage ? `${row.notClearedPercentage}%` : "0%"}
                              </TableCell> */}
                              <TableCell sx={cellStyle}>
                                {row.remarks || "N/A"}
                              </TableCell>
                            </TableRow>
                          ))
                        ) : (
                          <TableRow>
                            <TableCell
                              colSpan={7}
                              sx={{ ...cellStyle, textAlign: "center" }}
                            >
                              No data available
                            </TableCell>
                          </TableRow>
                        )}
                        {/* Total Row - shows totals for all data, not just current page */}
                        {noOfBinsGvpData && noOfBinsGvpData.length > 0 && (
                          <TableRow
                            sx={{
                              backgroundColor: isGHMC() ? "#0d5da5" : "#EC1117",
                              "& .MuiTableCell-root": {
                                color: "#fff",
                                fontWeight: 700,
                              },
                            }}
                          >
                            <TableCell sx={cellStyle} colSpan={2}
                            >
                              <span
                               style={{ color: "blue", cursor: "pointer" }}
                               onClick={(e) => handleDateClickALLDates( e)}
                              >Total</span>
                            </TableCell>

                            {/* <TableCell sx={cellStyle}></TableCell> */}

                            <TableCell sx={cellStyle}>
                              {totals.totalBins}
                            </TableCell>

                            <TableCell sx={cellStyle}>
                              {totals.totalAttendedBins}
                            </TableCell>

                            {/* <TableCell sx={cellStyle}>
                              {totals.pointsCleared}
                            </TableCell> */}

                            <TableCell sx={cellStyle}></TableCell>

                            {/* <TableCell sx={cellStyle}>
                              {totals.notCleared}
                            </TableCell> */}

                            <TableCell sx={cellStyle}></TableCell>

                            <TableCell sx={cellStyle}></TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  <TablePagination
                    component="div"
                    count={noOfBinsGvpData?.length || 0}
                    page={page}
                    onPageChange={handleChangePage}
                    rowsPerPage={rowsPerPage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    rowsPerPageOptions={[100, 500, 1000, 2000]}
                  />
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
